export var ProductType;
(function (ProductType) {
  ProductType["model"] = "model";
  ProductType["flatSheet"] = "flatSheet";
  ProductType["nFold"] = "nFold";
  ProductType["canvasPrint"] = "canvasPrint";
})(ProductType || (ProductType = {}));